export default "__VITE_ASSET__CHyzOzHV__"